module.exports = __webpack_public_path__ + "static/media/savonia-logo.78590e3a.jpg";